import React, {useState, useEffect, useContext} from "react";
import { AppContext } from './ContextVars';
import translations from './translations';

const Checkout = () => { // #created 2/5/25 TG
 
    const [amount, setAmount] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const {totalAmount, setTotalAmount} = useContext(AppContext);
    const [firstName, setFirstName] = useState(""); // #added 10/5/25 TG
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [country, setCountry] = useState("GT"); 
    const [currency, setCurrency] = useState("GTQ");
    const {totalAmountGTQ, setTotalAmountGTQ} = useContext(AppContext);
    const [errorMessage, setErrorMessage] = useState(""); // #added 15/5/25 TG
    const [city, setCity] = useState(""); // #added para los USA, expansión mundial papá! 23/5/25 TG
    const {purchaseDescription, setPurchaseDescription} = useContext(AppContext); // #added 23/5/25 TG
    const {cart, setCart, language} = useContext(AppContext);
    const t = (key) => translations.Checkout[key]?.[language] || key;
    const [products, setProducts] = useState([]); // Esto es para enviar a Tilopay y que luego nos lo devuelva y así podemos activar los pro... ductos TG #products #cart #added 25/5/25 TG


    // #state


    const countryOptions = [

      { label: "Guatemala", value: "GT" },
      { label: "United States", value: "US" },
      { label: "Mexico", value: "MX" },
      { label: "Canada", value: "CA" },


      // Central America
      { label: "El Salvador", value: "SV" },
      { label: "Honduras", value: "HN" },
      { label: "Nicaragua", value: "NI" },
      { label: "Costa Rica", value: "CR" },
      { label: "Panama", value: "PA" },
      { label: "Belize", value: "BZ" },
    

      // South America
      { label: "Argentina", value: "AR" },
      { label: "Bolivia", value: "BO" },
      { label: "Brazil", value: "BR" },
      { label: "Chile", value: "CL" },
      { label: "Colombia", value: "CO" },
      { label: "Ecuador", value: "EC" },
      { label: "Guyana", value: "GY" },
      { label: "Paraguay", value: "PY" },
      { label: "Peru", value: "PE" },
      { label: "Suriname", value: "SR" },
      { label: "Uruguay", value: "UY" },
      { label: "Venezuela", value: "VE" },
    
      
      // Caribbean
      { label: "Dominican Republic", value: "DO" },
      { label: "Puerto Rico", value: "PR" },
    
      // Other
      { label: "Other", value: "OTHER" }
    ];
    

      
    const handlePayment = async () => {
        try {
          setLoading(true); // #added 25/7/25 TG

          // Step 0: Validate inputs 
          if (!firstName || !lastName || !email || !country || !currency) { // #added 15/5/25 TG
            setErrorMessage("Please fill out all required fields.");
            return;
          }

          // Clear error if everything is fine
          setErrorMessage("");

          // Step 1: Get token from tilopay-get-token.php
          const tokenResponse = await fetch('https://eleven.fit/php/tilopay-get-token.php');
          const tokenData = await tokenResponse.json();
      
          if (!tokenData.success || !tokenData.access_token) {
            console.error('Failed to get token' , tokenData);
            alert('¡uh oh, there was an error!');
            return;
          }
      
          const accessToken = tokenData.access_token;
          console.log('Access Token:', accessToken);
      
          // Step 2: Define your payment data based on selected currency
          const paymentData = { // #mod 15/5/25 TG
            amount: currency === "USD" ? totalAmount : totalAmountGTQ,
            currency: currency,
            email: email,
            description: purchaseDescription,
            products: products, // #added 24/5/25 TG

            // Billing/shipping data
            firstName: firstName,
            lastName: lastName,
            phone: phone,
            country: country,
            city: city,
          };
          console.log("Payment Data (pre Tilopay): ", paymentData);
          /*const paymentData = { // #mod 10/5/25 TG
            amount: amount, // Example: 100.00 (in currency units, not cents)
            currency: 'USD',
            // name: 'John Doe',
            email: email,
            description: 'Workout App Plan A',

            firstName,
            lastName,
            phone,
            country
          };*/
          /*const paymentData = {
            amount: amount, // Example: 100.00 (in currency units, not cents)
            currency: 'USD',
            name: 'John Doe',
            email: 'john@example.com',
            description: 'Workout App Plan A',
          };*/
      
          // Step 3: Send to process-payment.php
          const paymentResponse = await fetch('https://eleven.fit/php/tilopay-process-payment.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: accessToken,
              ...paymentData,
            }),
          });
      
          const paymentResult = await paymentResponse.json();
          console.log("Payment Result:" + JSON.stringify(paymentResult));
          //   console.log('Payment response:', paymentResult);

          if (paymentResult.success) {
            console.log('Payment initiation successful!');
            const redirectUrl = paymentResult.data?.url;
          
            if (redirectUrl) {
              // Redirect to Tilopay hosted payment form
              window.location.href = redirectUrl;
            } else {
              console.error('No redirect URL received from Tilopay.');
              alert('Something went wrong: no redirect URL was provided.');
            }
          } else {
            console.log('Payment failed: ' + paymentResult.message);
            alert('Payment failed: ' + paymentResult.message);
          }
          
      
          /*if (paymentResult.success) {
            console.log('Payment initiation successful!');
          } else {
            console.log('Payment failed: ' + paymentResult.message);
            alert('Payment failed: ' + paymentResult.message);
          }*/
      
        } catch (error) {
          console.error('Payment error:', error);
        }
      };
      

    const handleCheckout2 = async () => {
      setLoading(true);
  
      try {
        const response = await fetch('https://eleven.fit/php/tilopay-get-token.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ amount, email }),
        });
  
        const data = await response.json();
  
        if (data.success) {
        //   window.location.href = data.checkoutUrl;
            console.log('success data: ', data);
        } else {
        //   alert('Error: ' + data.message);
          console.log("error data: ", data);
        }
        /*if (data.success && data.checkoutUrl) {
          window.location.href = data.checkoutUrl;
        } else {
          alert('Error: ' + data.message);
        //   console.log('Error: ' + data.message + ", httpCode: " + data.httpCode + ", curlError:" + data.curlError + ", tilopayResponse: " , data.tilopayResponse);
          console.log("error data: ", data);
        }*/
      } catch (err) {
        console.error(err);
        alert('Something went wrong');
      }
  
      setLoading(false);
    };
    
    useEffect(() => { // #added 7/5/25 TG
      setAmount(totalAmount);
    }, []);

    //--------------------------
    // #Description
    //--------------------------
    useEffect(() => {
      if (cart.length === 0) {
      } else if (cart.length === 1){
        // set the description to the name of the first item in the cart
        setPurchaseDescription(cart[0].name);
      } else if (cart.length > 1) {
        // set the description to the name of the first item in the cart
        setPurchaseDescription(cart[0].name + " and " + (cart.length - 1) + " more items");
      }
      
      // #Products Array for sendingg to backend #added 24/5/25 TG TG
      console.log("#Cart 🛒: ", JSON.stringify(cart));
      if (cart && cart.length > 0) {
        const productIds = cart.map(item => String(item.id)); // Convert to string
        setProducts(productIds);
      } else {
        setProducts([]); // Clear if cart is empty
      }

    }, [cart]);
        useEffect(() => {
          console.log("Products: ", products);
        }, [products]);

    //------------------------------------------
    // JSX
    //------------------------------------------
    return (
      <div className="p-4 max-w-md mx-auto">
        <h2 className="text-xl font-bold mb-4 general-h2 margin-top-70">{t('title')}</h2>
        
        {errorMessage && (
          <div className="text-red-600 mb-4 font-semibold">{errorMessage}</div>
        )}

        <p className="margin-top-30">{t('firstName')}</p>
        <input type="text" placeholder={t('firstName')} className="w-full border mb-2 p-2 text-black" style={{ color: '#000' }} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
        
        <p className="margin-top-10">{t('lastName')}</p>
        <input type="text" placeholder={t('lastName')} className="w-full border mb-2 p-2 text-black" style={{ color: '#000' }} value={lastName} onChange={(e) => setLastName(e.target.value)} />
  
        <p className="margin-top-10">{t('email')}</p>
        <input type="email" placeholder={t('email')} className="w-full border mb-2 p-2 text-black" style={{ color: '#000' }} value={email} onChange={(e) => setEmail(e.target.value)} />
  
        <p className="margin-top-10">{t('phone')}</p>
        <input type="text" placeholder={t('phone')} className="w-full border mb-2 p-2 text-black" style={{ color: '#000' }} value={phone} onChange={(e) => setPhone(e.target.value)} />
  
        <p className="margin-top-10">{t('country')} </p>
        <select
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          className="w-full border mb-2 p-2"
          style={{ color: '#000' }}
        >
          <option value="">{t('selectCountry')}</option>
          {countryOptions.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
          <option value="OTHER">{language === 'es' ? 'Otro' : 'Other'}</option>
        </select>
        
        <p className="margin-top-10">{t('city')}</p>
        <input type="text" placeholder={t('city')} className="w-full border mb-2 p-2 text-black" style={{ color: '#000' }} value={city} onChange={(e) => setCity(e.target.value)} />
  

        <p className="margin-top-10">{t('currency')} </p>

          {/* currency selector */}
          <select
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          className="w-full border mb-2 p-2"
          style={{ color: '#000' }}>
            <option value="GTQ">GTQ</option>
            <option value="USD">USD</option>
          </select>   


        <p className="margin-top-10">{t('total')} </p>
        <div className="font-size-36 font-weight-500 color-1">{currency === "USD" ? ("$"+totalAmount) : ("Q" + totalAmountGTQ) }</div>
        
        <p className="margin-top-10">{t('description')} </p>
        <div className="font-size-18 font-weight-300 color-gray-5">{purchaseDescription}</div>
  
        <button onClick={handlePayment} className="button-2 margin-top-20 margin-bottom-100" disabled={loading}>
          {loading ? t('processing') : t('payNow')}
        </button>
          <div>
            cart:
            {JSON.stringify(cart) /*#todelete */}
          </div>
          

            

      </div>
    );
    /*return (
      <div className="p-4 max-w-md mx-auto">
        <h2 className="text-xl font-bold mb-4">Checkout</h2>
        <input
          type="email"
          placeholder="Email"
          className="w-full border mb-2 p-2"
          style={{ color: '#000' }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          />
        <input
          type="number"
          placeholder="Amount"
          className="w-full border mb-4 p-2"
          style={{ color: '#000' }}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <button
          onClick={handlePayment}
          className="bg-blue-600 text-white py-2 px-4 rounded"
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Pay Now'}
        </button>
        {totalAmount}
      </div>
    );*/
    
};

export default Checkout;